var map = {
	"./annotation.svg": 11438,
	"./arrowLeft.svg": 93493,
	"./avatar.svg": 56358,
	"./burger.svg": 76324,
	"./calendar.svg": 81750,
	"./celebrationIcon.svg": 42848,
	"./checkCircle.svg": 26669,
	"./chevronDown.svg": 5122,
	"./clipboardCopy.svg": 32910,
	"./collection.svg": 14091,
	"./collection1.svg": 71086,
	"./cross.svg": 58124,
	"./documentDuplicate.svg": 70829,
	"./dotsHorizontal.svg": 57825,
	"./elipsesHorizontal.svg": 84356,
	"./exclamationCircle.svg": 13874,
	"./eye.svg": 53937,
	"./folder.svg": 84921,
	"./menu.svg": 9214,
	"./messageSquare.svg": 88114,
	"./moon.svg": 83599,
	"./officeBuilding.svg": 98652,
	"./pencil.svg": 88463,
	"./pencilAlt.svg": 45752,
	"./plus1.svg": 18503,
	"./plus2.svg": 10742,
	"./plusIcon.svg": 62041,
	"./search.svg": 25851,
	"./sortAscending.svg": 65434,
	"./sun.svg": 81440,
	"./tag.svg": 11230,
	"./userGroup.svg": 67490,
	"theme/images/annotation.svg": 11438,
	"theme/images/arrowLeft.svg": 93493,
	"theme/images/avatar.svg": 56358,
	"theme/images/burger.svg": 76324,
	"theme/images/calendar.svg": 81750,
	"theme/images/celebrationIcon.svg": 42848,
	"theme/images/checkCircle.svg": 26669,
	"theme/images/chevronDown.svg": 5122,
	"theme/images/clipboardCopy.svg": 32910,
	"theme/images/collection.svg": 14091,
	"theme/images/collection1.svg": 71086,
	"theme/images/cross.svg": 58124,
	"theme/images/documentDuplicate.svg": 70829,
	"theme/images/dotsHorizontal.svg": 57825,
	"theme/images/elipsesHorizontal.svg": 84356,
	"theme/images/exclamationCircle.svg": 13874,
	"theme/images/eye.svg": 53937,
	"theme/images/folder.svg": 84921,
	"theme/images/menu.svg": 9214,
	"theme/images/messageSquare.svg": 88114,
	"theme/images/moon.svg": 83599,
	"theme/images/officeBuilding.svg": 98652,
	"theme/images/pencil.svg": 88463,
	"theme/images/pencilAlt.svg": 45752,
	"theme/images/plus1.svg": 18503,
	"theme/images/plus2.svg": 10742,
	"theme/images/plusIcon.svg": 62041,
	"theme/images/search.svg": 25851,
	"theme/images/sortAscending.svg": 65434,
	"theme/images/sun.svg": 81440,
	"theme/images/tag.svg": 11230,
	"theme/images/userGroup.svg": 67490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37589;